/* eslint-disable camelcase, no-invalid-this */
import { html } from 'lit-element';
import { ifDefined } from 'lit-html/directives/if-defined';

export const render_segmented_control = function() {
  const {
    disabled,
    name,
    options,
    label,
    value,
    required
  } = this;
  return html`
      <fc-segmented-control
            .options="${ifDefined(options)}"
            label="${ifDefined(label)}"
            name="${ifDefined(name)}"
            value="${ifDefined(value)}"
            ?disabled="${disabled}"
            ?required="${required}"
            @change=${event => this.setValue(event.detail.value)}>
      </fc-segmented-control>
    `;
};
